/**
 * The top of another fan's profile: avatar, display name, `@username`, and
 * a slot for the actions the caller supplies. Renders only the props below,
 * and nothing else the underlying read might carry. `followsYou` adds the
 * "Follows you" chip beside the handle (ISSUE-1370); the server decides it.
 */
import type { ReactNode } from "react";

import { FOLLOWS_YOU_LABEL } from "../followers/followCopy";
import { ProfileAvatar } from "../profile/ProfileAvatar";

export type typeFanProfileHeaderProps = {
  displayName: string;
  username: string;
  photoUrl: string | null;
  actions?: ReactNode | undefined;
  followsYou?: boolean | undefined;
  testId?: string | undefined;
};

export const FanProfileHeader = (
  props: typeFanProfileHeaderProps,
): ReactNode => (
  <header
    className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-center sm:gap-4 sm:text-left"
    data-testid={props.testId}
  >
    <ProfileAvatar
      displayName={props.displayName}
      photoUrl={props.photoUrl}
      size="md"
      labelling="decorative"
      testId="fan-avatar"
    />
    <div className="flex flex-col gap-1">
      <h1 className="text-h1 text-ink" data-testid="fan-display-name">
        {props.displayName}
      </h1>
      <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-start">
        <p className="text-body text-ink-secondary" data-testid="fan-username">
          {`@${props.username}`}
        </p>
        {props.followsYou === true ? (
          <span
            className="rounded-full bg-surface-sunken px-2 py-1 text-caption text-ink-secondary"
            data-testid="fan-follows-you"
          >
            {FOLLOWS_YOU_LABEL}
          </span>
        ) : null}
      </div>
    </div>
    {props.actions}
  </header>
);
